import { createAsyncThunk } from "@reduxjs/toolkit";
import { BranchCode } from "api/risk";
import { RootState } from "app/store";
import { SubscriptionProcessStepIdentifier } from "features/subscription-process/types/interfaces";
import { borrowersAPI } from "services/swagger-api";

interface FetchRiskDataParams {
  branchCode: BranchCode,
  riskId: string,
  stepIdentifier: SubscriptionProcessStepIdentifier
}

export const fetchStepData = createAsyncThunk<any,
  FetchRiskDataParams,
  { rejectValue: string, getState: RootState }
>(
  'subscriptionProcess/fetchBranchData',
  async ({ branchCode, riskId, stepIdentifier }, { getState }) => {
    switch (branchCode) {
      case BranchCode.Borrower:
        const response = await borrowersAPI.getBorrowerProjectById({ borrowerProjectId: riskId })
        return {
          riskId,
          data: {
            [stepIdentifier]: response
          }
        }
    }
  }
);
